import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';

import CustomSelectChips from 'components/CustomSelectChips';
import { RootState } from 'store';

import { IIdentityRegisterFormProps } from './interfaces';

const IdentityRegisterForm: React.FC<IIdentityRegisterFormProps> = ({
  isViewOnly,
}: IIdentityRegisterFormProps) => {
  const { list } = useSelector((state: RootState) => state.policyList);

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="stretch"
    >
      {!isViewOnly && (
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid item>
            <Typography
              data-cy="identity-register-form__label--user-id"
              variant="subtitle1"
            >
              ID do usuário
            </Typography>
          </Grid>
          <Field
            data-cy="identity-register-form__input--user-id"
            component={TextField}
            fullWidth
            name="identity"
            disabled={isViewOnly}
          />
          <Grid item>
            <Typography
              data-cy="identity-register-form__label--password"
              variant="subtitle1"
            >
              Senha
            </Typography>
          </Grid>
          <Field
            data-cy="identity-register-form__input--password"
            component={TextField}
            fullWidth
            name="password"
            type="password"
            disabled={isViewOnly}
          />
        </Grid>
      )}
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
      >
        <Grid item>
          <Typography
            data-cy="identity-register-form__label--policy"
            variant="subtitle1"
          >
            Perfis
          </Typography>
        </Grid>

        <Grid item>
          <CustomSelectChips
            isViewOnly={isViewOnly}
            list={list.map((policy) => ({
              value: policy._id,
              label: policy.name,
            }))}
            fieldName={`policies`}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IdentityRegisterForm;
